export default "__VITE_ASSET__r0l0RATn__"